module.exports = __webpack_public_path__ + "a5bc6658265af922dec90c22dfe17fac.svg";